<section class="grid md:grid-cols-12 md:h-screen">
    <!-- Left Panel -->
    <div class="md:p-6 p-4 md:col-span-3 flex flex-col gap-6 border-r-0 border-b pb-10 border-[#DAE1E4] rtl:border-r-0 rtl:md:border-l md:border-r 
        md:border-b-0 rtl:pr-6 pr-5 rtl:md:pl-5">
        <p class="text-generic">{{ 'HELP_CENTER.PLEASE_SELECT' | translate }}</p>

        <!-- Feedback Button -->
        <button class="btn-option group" (click)="select('feedback')" [ngClass]="{
        'border border-(--brand-primary)': selected === 'feedback',
        'opacity-60': selected === 'complaint'
      }">
            <span class="btn-icon-wrapper group-hover:opacity-80">
                <img src="assets/icons/pen.svg" alt="Feedback" class="btn-icon" />
            </span>
            <span class="truncate">{{ 'HELP_CENTER.FEEDBACK' | translate }}</span>
        </button>

        <!-- Complaint Button -->
        <button class="btn-option group" (click)="select('complaint')" [ngClass]="{
        'border border-(--brand-primary)': selected === 'complaint',
        'opacity-60': selected === 'feedback'
      }">
            <span class="btn-icon-wrapper group-hover:opacity-80">
                <img src="assets/icons/user.svg" alt="Complaint" class="btn-icon" />
            </span>
            <span class="truncate">{{ 'HELP_CENTER.COMPLAINT' | translate }}</span>
        </button>
    </div>

    <!-- Right Panel -->
    <div class="md:col-span-9 overflow-y-visible md:pt-6 pt-4 md:p-6 p-4 pb-50!">
        <p class="text-generic md:mb-6 mb-4">{{ 'HELP_CENTER.ENTER_DETAILS' | translate }}</p>

        <!-- Default / No action -->
        <div *ngIf="selected === 'none'" class="text-center py-10 text-(--text-muted)">
            <img src="assets/icons/file.svg" alt="icon" class="mx-auto mb-5 h-14 w-14" />
            <p class="text-generic mb-2">{{ 'HELP_CENTER.NO_ACTION' | translate }}</p>
            <p>{{ 'HELP_CENTER.PLEASE_SELECT_ACTION' | translate }}</p>
        </div>

        <!-- Feedback Form -->
        <form *ngIf="selected === 'feedback'" class="space-y-6 pb-5 mx-1" novalidate>
            <app-textarea-field label="HELP_CENTER.FEEDBACK" placeholder="HELP_CENTER.PLACEHOLDER" row="1"
                [control]="feedbackControl" [maxLength]="maxLengthForTextArea"></app-textarea-field>

            <app-file-upload (filesChanged)="onFilesChanged($event)"></app-file-upload>

            <app-button text="HELP_CENTER.SUBMIT_FEEDBACK" type="button" variant="primary" size="lg" extraClass="mt-8"
                (click)="submitFeedback()"
                [disabled]="feedbackControl.invalid || (feedbackControl.value.trim().length || 0) === 0 || (feedbackControl.value.trim().length || 0) > maxLengthForTextArea">
            </app-button>
        </form>

        <!-- Complaint Form -->
        <form *ngIf="selected === 'complaint'" class="space-y-4 pb-5 mx-1" novalidate>
            <app-custom-dropdown label="HELP_CENTER.REASON" placeholder="HELP_CENTER.PLEASE_SELECT"
                [options]="complaintReasons" (optionSelected)="onReasonSelect($event)"></app-custom-dropdown>

            <app-textarea-field label="HELP_CENTER.COMPLAINT" placeholder="HELP_CENTER.PLACEHOLDER"
                [control]="complaintControl" [maxLength]="maxLengthForTextArea"></app-textarea-field>

            <app-file-upload (filesChanged)="onFilesChanged($event)"></app-file-upload>

            <app-button text="HELP_CENTER.SUBMIT_COMPLAINT" type="button" variant="primary" size="lg" extraClass="mt-8"
                (click)="submitComplaint()" [disabled]="
    !selectedReason ||
    complaintControl.invalid ||
    (complaintControl.value.trim().length || 0) === 0 ||
    (complaintControl.value.trim().length || 0) > maxLengthForTextArea
  ">
            </app-button>
        </form>
    </div>
</section>